import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import Icon from "../components/Icon";
import BenefitsRow from "../components/BenefitsRow";
import { STEPS } from "../data/content";

const HowToUse = () => {
  const navigate = useNavigate();
  return (
    <div>
      <PageHero
        overline="Daily Ritual"
        title="A daily ritual, simplified."
        subtitle="Science-backed wellness made effortless. Just 4 simple steps to your daily wellness boost."
      >
        <button
          onClick={() => navigate("/product")}
          data-testid="howto-shop-now"
          className="mt-9 inline-flex items-center gap-2 bg-navy-900 text-white rounded-full px-8 py-4 font-medium hover:bg-navy-800 transition-all hover:-translate-y-0.5"
        >
          Start your ritual <ArrowRight className="w-4 h-4" />
        </button>
      </PageHero>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div className="relative bg-white rounded-3xl p-8 border border-slate-100 h-full hover:shadow-xl transition-all duration-300">
                <span className="absolute top-6 right-7 font-heading text-5xl font-bold text-slate-100">{s.step}</span>
                <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-royal text-white mb-6">
                  <Icon name={s.icon} className="w-7 h-7" />
                </span>
                <h3 className="font-heading text-xl font-semibold text-navy-900">{s.title}</h3>
                <p className="text-slate-500 mt-3 leading-relaxed text-sm">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#FAFBFD] border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
          <Reveal className="text-center max-w-xl mx-auto mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-navy-900">Supporting 7 systems, daily.</h2>
          </Reveal>
          <BenefitsRow compact />
        </div>
      </section>
    </div>
  );
};

export default HowToUse;
